import { Component, ComponentFactory, NgModule, Input, Injectable } from '@angular/core';
import {Compiler, CompilerFactory, COMPILER_OPTIONS } from '@angular/core'
import { DpsEntitiesModule } from '../dps-entities.module';
let _ = require('lodash');

export interface DynamicData {
    entity: any;
}

@Injectable()
export class ContentTypeBuilder {

    private _cacheOfFactories: {[templateKey: string]: ComponentFactory<DynamicData>} = {};

    constructor( protected compiler: Compiler) {
    }

    public createComponentFactory(template: string)
    : Promise<ComponentFactory<DynamicData>> {

        let factory = this._cacheOfFactories[template];

        if (factory) {
            return new Promise((resolve) => {
                resolve(factory);
            });
        }

        let type   = this.createNewComponent(template);
        let module = this.createComponentModule(type);

        return new Promise((resolve) => {
            this.compiler
                .compileModuleAndAllComponentsAsync(module)
                .then((moduleWithFactories) =>
                {
                    factory = _.find(moduleWithFactories.componentFactories, { componentType: type });
                    this._cacheOfFactories[template] = factory;
                    resolve(factory);
                });
        });
    }
    protected createNewComponent (tmpl:string) {
        @Component({
            selector: 'dynamic-tree-details-component',
            template: tmpl,
        })
        class CustomDynamicComponent  implements DynamicData {
            @Input() entity: any;
        };
        return CustomDynamicComponent;
    }
    protected createComponentModule (componentType: any) {
        @NgModule({
            imports:[
                DpsEntitiesModule
            ],
            declarations: [
                componentType
            ],
        })
        class RuntimeComponentModule {
        }
        return RuntimeComponentModule;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/content-switcher/content-type-builder.ts